import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Wraps route content and re-triggers the fadeSlideUp animation whenever
 * the route (pathname) changes, by remounting via the `key`.
 */
const PageTransition = ({ children }) => {
  const location = useLocation();
  return (
    <div className="i-ems-page-transition" key={location.pathname}>
      {children}
    </div>
  );
};

export default PageTransition;
